import { deleteHandler, getHandler, patchHandler, postHandler } from 'src/utils/fetchHandler';
import { getPendingGiftBucketsDelete, getPendingGiftBucketsUpdate } from './giftBucket.selector';

export const CLEAR_GIFT_BUCKETS = 'CLEAR_GIFT_BUCKETS/GIFT_BUCKETS/@WISELY/WEB';
export const CLEAR_GIFT_BUCKET_UPDATE_ERRORS =
	'CLEAR_GIFT_BUCKET_UPDATE_ERRORS/GIFT_BUCKETS/@WISELY/WEB';
export const CLEAR_GIFT_BUCKET_CREATE_ERRORS =
	'CLEAR_GIFT_BUCKET_CREATE_ERRORS/GIFT_BUCKETS/@WISELY/WEB';
export const GET_GIFT_BUCKETS = 'GET_GIFT_BUCKETS/GIFT_BUCKETS/@WISELY/WEB';
export const FETCH_GIFT_BUCKETS_FAILED = 'FETCH_GIFT_BUCKETS_FAILED/GIFT_BUCKETS/@WISELY/WEB';
export const FETCH_GIFT_BUCKETS_SUCCEEDED = 'FETCH_GIFT_BUCKETS_SUCCEEDED/GIFT_BUCKETS/@WISELY/WEB';
export const UPDATE_GIFT_BUCKET = 'UPDATE_GIFT_BUCKET/GIFT_BUCKETS/@WISELY/WEB';
export const UPDATE_GIFT_BUCKET_FAILED = 'UPDATE_GIFT_BUCKET_FAILED/GIFT_BUCKETS/@WISELY/WEB';
export const UPDATE_GIFT_BUCKET_SUCCEEDED = 'UPDATE_GIFT_BUCKET_SUCCEEDED/GIFT_BUCKETS/@WISELY/WEB';
export const CREATE_GIFT_BUCKET = 'CREATE_GIFT_BUCKET/GIFT_BUCKETS/@WISELY/WEB';
export const CREATE_GIFT_BUCKET_FAILED = 'CREATE_GIFT_BUCKET_FAILED/GIFT_BUCKETS/@WISELY/WEB';
export const CREATE_GIFT_BUCKET_SUCCEEDED = 'CREATE_GIFT_BUCKET_SUCCEEDED/GIFT_BUCKETS/@WISELY/WEB';
export const DELETE_GIFT_BUCKET = 'DELETE_GIFT_BUCKET/GIFT_BUCKETS/@WISELY/WEB';
export const DELETE_GIFT_BUCKET_SUCCEEDED = 'DELETE_GIFT_BUCKET_SUCCEEDED/GIFT_BUCKETS/@WISELY/WEB';
export const DELETE_GIFT_BUCKET_FAILED = 'DELETE_GIFT_BUCKET_FAILED/GIFT_BUCKETS/@WISELY/WEB';

export const clearGiftBuckets = () => ({
	type: CLEAR_GIFT_BUCKETS,
});

export const getGiftBuckets = () => ({
	type: GET_GIFT_BUCKETS,
});

export const fetchGiftBucketsSucceeded = payload => ({
	type: FETCH_GIFT_BUCKETS_SUCCEEDED,
	payload,
});

export const fetchGiftBucketsFailed = payload => ({
	type: FETCH_GIFT_BUCKETS_FAILED,
	payload,
});

export const fetchGiftBuckets = () => {
	return dispatch => {
		dispatch(getGiftBuckets());
		const path = `v2/gift_buckets`;

		return getHandler(path)
			.then(json => dispatch(fetchGiftBucketsSucceeded(json)))
			.catch(error => {
				console.error('fetchGiftBuckets error', error);
				dispatch(fetchGiftBucketsFailed(error));
			});
	};
};

export const updateGiftBucket = () => ({
	type: UPDATE_GIFT_BUCKET,
});

export const requestUpdateGiftBucketFailed = payload => ({
	type: UPDATE_GIFT_BUCKET_FAILED,
	payload,
});

export const requestUpdateGiftBucketSucceeded = payload => ({
	type: UPDATE_GIFT_BUCKET_SUCCEEDED,
	payload,
});

export const requestUpdateGiftBucket = (id, body) => {
	return async (dispatch, getState) => {
		if (getPendingGiftBucketsUpdate(getState())) {
			return;
		}
		dispatch(updateGiftBucket());
		const path = `v2/gift_buckets/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateGiftBucketSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateGiftBucket error', error);
				dispatch(requestUpdateGiftBucketFailed(error));
			});
	};
};

export const createGiftBucket = () => ({
	type: CREATE_GIFT_BUCKET,
});

export const requestCreateGiftBucketFailed = payload => ({
	type: CREATE_GIFT_BUCKET_FAILED,
	payload,
});

export const requestCreateGiftBucketSucceeded = payload => ({
	type: CREATE_GIFT_BUCKET_SUCCEEDED,
	payload,
});

export const requestCreateGiftBucket = body => {
	return async dispatch => {
		dispatch(createGiftBucket());
		const path = `v2/gift_buckets`;

		return postHandler(path, JSON.stringify(body))
			.then(json => {
				dispatch(requestCreateGiftBucketSucceeded(json));
			})
			.catch(error => {
				console.error('requestCreateGiftBucket error', error);
				dispatch(requestCreateGiftBucketFailed(error));
			});
	};
};

export const deleteGiftBucket = () => ({
	type: DELETE_GIFT_BUCKET,
});

export const requestDeleteGiftBucketSucceeded = payload => ({
	type: DELETE_GIFT_BUCKET_SUCCEEDED,
	payload,
});

export const requestDeleteGiftBucketFailed = payload => ({
	type: DELETE_GIFT_BUCKET_FAILED,
	payload,
});

export const requestDeleteGiftBucket = id => {
	return async (dispatch, getState) => {
		if (getPendingGiftBucketsDelete(getState())) {
			return;
		}
		dispatch(deleteGiftBucket());
		const path = `v2/gift_buckets/${id}`;

		return deleteHandler(path)
			.then(json => dispatch(requestDeleteGiftBucketSucceeded(json)))
			.catch(error => {
				console.error('requestDeleteGiftBucketFailed error', error);
				dispatch(requestDeleteGiftBucketFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/giftBuckets/giftBucket.action.js